<template>
    <b-card>
        <loading :active.sync="isLoading">
        </loading>

        <div class="card-header">
            <h3>Create a new survey</h3>
        </div>
        <b-form class="card-body" @submit.prevent="submit">
            <b-form-group label="Title" label-for="title-input">
                <span v-if="errors.has('title')" class="alert-danger">{{
                    errors.first('title') }}</span>
                <b-form-input id="title-input" name="title" type="text" v-model="survey.title"
                              v-validate="'required'"></b-form-input>
            </b-form-group>
            <b-form-group label="Client name" label-for="client-name-input">
                <span v-if="errors.has('clientName')" class="alert-danger">{{
                    errors.first('clientName') }}</span>
                <b-form-input id="client-name-input" name="clientName" type="text" v-model="survey.clientName"
                              v-validate="'required'" data-vv-as="client name"></b-form-input>
            </b-form-group>
            <b-form-group label="Description" label-for="desc-input">
                <b-form-textarea v-model="survey.description"></b-form-textarea>
            </b-form-group>
            <b-form-group label="Survey Type" style="width: 100px;" label-for="desc-input">
                <b-form-select id="type" v-model="survey.type">
                <template>
                    <option value="visualize" selected>visualize</option>
                    <option value="survey">survey</option>
                </template>
                </b-form-select>
            </b-form-group>
            <b-form-group label="Sequence number" label-for="seq-input" v-if="survey.type=='visualize'">
                <b-form-input id="seq-input" style="width: 100px; text-align: center;" type="text"
                              v-model="survey.sequenceNumber"></b-form-input>
            </b-form-group>
            <!-- <b-form-group label="Sequence number" label-for="seq-input">
                <b-form-spinbutton id="seq-input" style="width: 150px;" v-model="survey.sequenceNumber" min="1" max="100"></b-form-spinbutton>
            </b-form-group> -->
            <b-form-group label="Survey period" label-for="start-date-input">
                <span v-if="errors.has('startDate')" class="alert-danger">{{
                    errors.first('startDate') }}</span>
                <br v-if="errors.has('startDate') && errors.has('endDate')">
                <span v-if="errors.has('endDate')" class="alert-danger">{{
                    errors.first('endDate') }}</span>
                <div>
                    <b-input-group class="form-inline w-25" style="float:left">
                        <b-form-input id="start-date-input" name="startDate" v-model="selectedStartDate"
                                      v-validate="dateRule" type="text" placeholder="Choose a Start date"
                                      data-vv-as="start date"></b-form-input>
                        <b-input-group-append>
                            <b-form-datepicker v-model="selectedStartDate" button-only right aria-controls="example-input"
                                               data-vv-as="end date" :max="survey.type=='visualize' ? endDate : ''"></b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                    <h3 style="float:left">~</h3>
                    <b-input-group class="form-inline w-25">
                        <b-form-input id="end-date-input" name="endDate" v-model="selectedEndDate" v-validate="dateRule"
                                      data-vv-as="end date" type="text" placeholder="Choose a End date"></b-form-input>
                        <b-input-group-append>
                            <b-form-datepicker v-model="selectedEndDate" button-only right
                                               aria-controls="example-input" :min="startDate"></b-form-datepicker>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-form-group>

            <b-form-group label="Add a file" label-for="file-input">
                <span v-if="errors.has('file')" class="alert-danger">{{
                    errors.first('file') }}</span>
                <b-form-file ref='file-input' id="file-input" name="file" v-model="survey.file"
                             placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"></b-form-file>
            </b-form-group>

            <b-button type="submit" variant="primary" class="mr-1">Submit</b-button>
            <!-- <b-button @click="reset" type="button" variant="danger" class="mr-1">Reset</b-button> -->
            <b-button @click="cancel" type="button">Cancel</b-button>
        </b-form>

        <b-modal id="surveyFormModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary"
                 ok-title="Close">
            <p class="my-4 text-center">{{ msgContent }}</p>
        </b-modal>
    </b-card>
</template>

<script>
import Loading from 'vue-loading-overlay';
//import { WORKMAN_URL } from '../../const';

export default ({
    components: {
        Loading,
    },
    data() {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const maxDate = new Date(today)
        return {
            survey: {
                title: '',
                description: '',
                clientName: '',
                sequenceNumber: null,
                startDate: '',
                type:'visualize', // visualize(시각화)/survey(설문지)
                file: null,
            },
            isLoading: false,
            msgStatus: '',
            msgContent: '',

            selectedDate: new Date(),
            selectedStartDate: null,
            startDate : new Date(),
            selectedEndDate: null,
            endDate : new Date(),
            max: maxDate,
            dateRule: { required: true, regex: /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/ },
        }
    },
    watch: {
        selectedStartDate() {
            this.startDate = new Date(this.selectedStartDate)
        },
        selectedEndDate(){
            this.endDate = new Date(this.selectedEndDate)
        }
    },
    methods: {
        
        generateKey(key) {
            return key + new Date().toString();
        },
        addFile() {
            if (!this.file) return;
            const original = this.file;
            const clone = new File([original], original.name, {
                type: original.type,
                lastModified: original.lastModified,
            });
            this.survey.file = clone;
            this.$refs['file-input'].reset();
        },
        openDatepicker(datepicker) {
            if (datepicker == 'historyDatepicker') {
                this.$refs.historyDatepicker.showCalendar();
            }
        },
        deleteFile() {
            this.survey.file = null;
        },
        reset() {
            this.survey = {
                title: '',
                description: '',
                clientName: '',
                sequenceNumber: null,
                startDate: '',
                file: null,
                type:'visualize'
            };
            this.file = null;
            this.isLoading = false;
            this.msgStatus = '';
            this.msgContent = '';
            this.selectedDate = new Date();
        },
        cancel() {
            this.reset();
            this.$router.push('/survey')
        },
        async submit() {
            try {
                this.isLoading = true;

                let result = await this.$validator.validate();
                if (!result) return;

                // Create formData
                let params = new FormData();
                params.append('title', this.survey.title);
                params.append('clientName', this.survey.clientName);
                params.append('description', this.survey.description);
                params.append('seq', this.survey.sequenceNumber);
                params.append('startDate', this.$moment(this.selectedStartDate).format('YYYY-MM-DD'));
                params.append('endDate', this.$moment(this.selectedEndDate).format('YYYY-MM-DD'));
                params.append('file', this.survey.file);
                params.append('type', this.survey.type);

                // Submit a new survey
                await axios.post('survey/addSurvey',
                    params,
                    {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'multipart/form-data',
                            'Authorization': accessToken()
                        }
                    }).then(response => {
                        this.isLoading = false;
                        this.$router.push('/survey');
                        this.$bvToast.toast(`survey 등록이 완료 되었습니다.`, {
                            title: `Notification`,
                            toaster: "b-toaster-bottom-center",
                            solid: true,
                            appendToast: false,
                            autoHideDelay: 400 
                            }
                        );
                    });

            } catch (error) {
                if (error.response) {
                    this.msgStatus = error.response.status;
                }
                this.msgContent = error.message;
                this.$bvModal.show('surveyFormModal');
            } finally {
                this.isLoading = false;
            }
        }
    }
})
</script>